import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { audiencesService } from '../services';
import type { AudienceDropdownItem, AudienceIdentifierType } from '@troia-v3/types';

export interface UseAudiencesDropdownOptions {
  enabled?: boolean;
}

export const useAudiencesDropdown = (
  identifierType?: AudienceIdentifierType,
  options: UseAudiencesDropdownOptions = {}
): UseQueryResult<AudienceDropdownItem[], Error> => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: ['audiences-dropdown', identifierType],
    queryFn: () => audiencesService.getForDropdown(identifierType),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
